import { render, staticRenderFns } from "./CheckboxBase.vue?vue&type=template&id=443024e6&scoped=true"
import script from "./CheckboxBase.vue?vue&type=script&lang=js"
export * from "./CheckboxBase.vue?vue&type=script&lang=js"
import style0 from "./CheckboxBase.vue?vue&type=style&index=0&id=443024e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443024e6",
  null
  
)

/* custom blocks */
import block0 from "Components/01-atoms/form/input/translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F01-atoms%2Fform%2Fcheckbox%2FCheckboxBase.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports